import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class Licenses extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/security/licensePermission'
    super(store, path)
  }

  create(model, showProgress) {
    return this._request({
      method: 'POST',
      action: 'create',
      body: model,
      showProgress
    })
  }

  update(id, model, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  getById(id, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'GET',
      showProgress
    })
  }

  delete(id, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'DELETE',
      showProgress
    })
  }

  enable(Id, showProgress) {
    return this._request({
      action: `${this._urlencode(Id)}/enable`,
      method: 'PATCH',
      showProgress
    })
  }

  disable(Id, showProgress) {
    return this._request({
      action: `${this._urlencode(Id)}/disable`,
      method: 'PATCH',
      showProgress
    })
  }

  list(filter, showProgress) {
    return this._request({
      action: 'list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
